import Vue from 'vue';
import VueRouter from 'vue-router';
import App from '@/components/App.vue';
import routes from './routes';
import store from './store';

import BootstrapVue from 'bootstrap-vue';
import VueAsyncComputed from 'vue-async-computed';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Loader from '@/components/shared/Loader';
import ConfirmModal from '@/components/shared/ConfirmModal';
import ErrorModal from '@/components/shared/ErrorModal';
import ProcessingModal from '@/components/shared/ProcessingModal';

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(VueAsyncComputed);
Vue.use(BootstrapVue);

import '@/assets/scss/custom.scss';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('elumin-loader', Loader);
Vue.component('ConfirmModal', ConfirmModal);
Vue.component('ErrorModal', ErrorModal);
Vue.component('ProcessingModal', ProcessingModal);

let router = new VueRouter({
	routes
});

Vue.filter(
	'capitalize',
	function(value)
	{
		if(!value)
			return '';
		
		value = value.toString();
		
		return value.charAt(0).toUpperCase() + value.slice(1);
	}
);

if(window.location.protocol != 'https:')
	location.href = location.href.replace("http://", "https://");

window.vm = new Vue({
	render: h => h(App, { ref: "app" }),
	router,
	store
}).$mount('#app');
